module.exports = __webpack_public_path__ + "static/media/link.b0f412be.svg";